export default __webpack_public_path__ + "static/media/down.903eaa19.svg";